var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SharedService } from './shared.service';
import { KeycloakService } from './keycloak.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/Rx';
import { HttpClientWrapper } from './httpClient';
var CommonService = (function (_super) {
    __extends(CommonService, _super);
    function CommonService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        _this.ipLocal = "";
        // Observable string sources
        _this.emitChangeBlock = new Subject();
        // Observable string streams
        _this.changeEmitted$ = _this.emitChangeBlock.asObservable();
        _this.emitAddTimeCaptchaExp = new Subject();
        _this.addTimeEmittedExp$ = _this.emitAddTimeCaptchaExp.asObservable();
        _this.emitEnvioMailCaptcha = new Subject();
        _this.envioMailEmitted$ = _this.emitEnvioMailCaptcha.asObservable();
        _this.emitAddTimeCaptchaAct = new Subject();
        _this.addTimeEmittedAct$ = _this.emitAddTimeCaptchaAct.asObservable();
        _this.cantApExp = 0;
        _this.cantApAct = 0;
        _this.cantCaptchaSolAct = 0;
        _this.cantCaptchaSolExp = 0;
        _this.ipLocal = "";
        return _this;
    }
    // Service message commands
    CommonService.prototype.emitBlocking = function (change) {
        this.emitChangeBlock.next(change);
    };
    CommonService.prototype.addTimeExp = function (time) {
        this.emitAddTimeCaptchaExp.next(time);
    };
    CommonService.prototype.chequearEnvioMail = function (cod) {
        this.emitEnvioMailCaptcha.next(cod);
    };
    CommonService.prototype.addTimeAct = function (time) {
        this.emitAddTimeCaptchaAct.next(time);
    };
    CommonService.prototype.quitaacentos = function (str) {
        var r = str.toLowerCase();
        //r = r.replace(new RegExp(/\s/g),"");
        r = r.replace(new RegExp(/[àáâãäå]/g), "a");
        r = r.replace(new RegExp(/[èéêë]/g), "e");
        r = r.replace(new RegExp(/[ìíîï]/g), "i");
        r = r.replace(new RegExp(/ñ/g), "n");
        r = r.replace(new RegExp(/[òóôõö]/g), "o");
        r = r.replace(new RegExp(/[ùúûü]/g), "u");
        return r;
    };
    CommonService.prototype.findLocalidades = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "localidades.json";
        }
        else {
            wsUrl = this.urlSer() + "home/localidades";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findOrganismos = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "organismos.json";
        }
        else {
            wsUrl = this.urlSer() + "home/organismos";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findOrgByCir = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "organismos.json";
        }
        else {
            wsUrl = this.urlSer() + "home/organismos/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findOrgByCedulas = function (cod) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "organismos.json";
        }
        else {
            wsUrl = this.urlSer() + "home/orgByCed";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findSecByOrg = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "secretarias.json";
        }
        else {
            wsUrl = this.urlSer() + "home/secretarias/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findOrgForIngreso = function (fue, inst, cir) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = "app/data/" + "organismos.json";
        }
        else {
            wsUrl = this.urlSer() + "home/orgForIngreso?fue=" + fue + "&ins=" + inst + "&cir=" + cir;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findMenus = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = "app/data/" + "menus.json";
        }
        else {
            wsUrl = this.urlSer() + "home/menus/" + KeycloakService.getLoggedUser();
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findRepresentantes = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "represent.json";
        }
        else {
            wsUrl = this.urlSer() + "usuarios/representantes";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposDocumentos = function () {
        var wsUrl;
        wsUrl = "app/data/tipoDocs.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposDocumentosJur = function () {
        var wsUrl;
        wsUrl = "app/data/tipoDocsJur.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposPersona = function () {
        var wsUrl;
        wsUrl = "app/data/tipoPersona.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findParteCausaExample = function () {
        var wsUrl;
        //if (this.isLocalData()) {
        wsUrl = "app/data/partesCausaExample.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
        //} 
    };
    CommonService.prototype.findCir = function () {
        var wsUrl;
        wsUrl = "app/data/circunscripcion.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findFue = function () {
        var wsUrl;
        wsUrl = "app/data/fueros.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposVinculo = function (tex_cod) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tipoVinculos.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/tiposVinculos/" + tex_cod;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposVinculoByConcepto = function (tex_cod, ttr) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tipoVinculos.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/tiposVinculosByConcepto?tex=" + tex_cod + "&ttr=" + ttr;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findConceptos = function (tex_cod, fuero, tipo, inst, cir) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "concepto.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/conceptos?tex=" + tex_cod + "&fue=" + fuero + "&tipo=" + tipo + "&inst=" + inst + "&cir=" + cir;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findNivel = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "nivel.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/nivelacceso";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findAvisos = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "notificacion.json";
        }
        else {
            wsUrl = this.urlSer() + "usuarios/avisos/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.updateAvisos = function (id, cod) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "notificacion.json";
        }
        else {
            wsUrl = this.urlSer() + "usuarios/updateAvisos/" + id + "/" + cod;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findPreferencia = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "preferencia.json";
        }
        else {
            wsUrl = this.url() + "preferencias/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findFuncionalidades = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "funcionalidades.json";
        }
        else {
            wsUrl = this.urlSer() + "home/funcionalidades";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.addAuditoria = function (accion) {
        var wsUrl;
        if (!this.isLocalData()) {
            wsUrl = this.urlSer() + "home/auditoria/" + KeycloakService.getLoggedUser() + "/" + accion;
            // https://stackoverflow.com/questions/5515310/is-there-a-standard-function-to-check-for-null-undefined-or-blank-variables-in
            if (this.ipLocal && accion == "LOGIN") {
                wsUrl = wsUrl + "?ip=" + this.ipLocal;
            }
            //console.log("ADD AUDITORIA " + wsUrl);
            return this._http.get(wsUrl).map(function (response) { return response.json(); });
        }
        else {
            return new Observable(function (observer) {
                //return () => console.log("mockup observable");
                return function () { };
            });
        }
    };
    CommonService.prototype.addAuditoriaMail = function (accion) {
        var wsUrl;
        var mail = true;
        if (!this.isLocalData()) {
            wsUrl = this.urlSer() + "home/auditoria/" + KeycloakService.getLoggedUser() + "/" + accion;
            wsUrl = wsUrl + "?enviamail=" + mail;
            //console.log("ADD AUDITORIA MAIL " + wsUrl);
            return this._http.get(wsUrl).map(function (response) { return response.json(); });
        }
        else {
            return new Observable();
        }
    };
    CommonService.prototype.sendMail = function (asunto, msg) {
        var wsUrl;
        if (this.isLocalData()) {
            //console.log("Enviar mail asunto: " + asunto + " meg " + btoa(msg));
            return new Observable();
        }
        else {
            wsUrl = this.urlSer() + "home/sendmail/" + KeycloakService.getLoggedUser();
            wsUrl = wsUrl + "?asunto=" + asunto + "&msg=" + btoa(SharedService.unescape(encodeURIComponent(msg)));
            //console.log("Enviar mail " + wsUrl);
            return this._http.get(wsUrl).map(function (response) { return response.toString(); });
        }
    };
    CommonService.prototype.findTiposTasas = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tipoTasas.json";
        }
        else {
            wsUrl = this.urlSer() + "home/tiposTasas";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposTasasByTipo = function (tipo) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tipoTasas.json";
        }
        else {
            wsUrl = this.urlSer() + "home/tiposTasasByTipo/" + tipo;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    // CRUD WS GLOBAL
    CommonService.prototype.findById = function (path) {
        return this._http.get(this.url() + path)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.find = function (path) {
        return this._http.get(this.url() + path)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.remove = function (path) {
        return this._http.delete(this.url() + path)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.update = function (path, item) {
        return this._http.post(this.url() + path, item)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.insert = function (path, item) {
        return this._http.put(this.url() + path, item)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.tienePermiso = function (funcion) {
        var allow = false;
        if (typeof (KeycloakService.usr.permisos) != 'undefined') {
            KeycloakService.usr.permisos.forEach(function (element) {
                if (element.codigo == funcion) {
                    allow = true;
                }
            });
        }
        ;
        return allow;
    };
    CommonService.prototype.getConfiguracion = function (codigo) {
        var tit = "";
        if (typeof (KeycloakService.usr.configuraciones) != 'undefined') {
            KeycloakService.usr.configuraciones.forEach(function (element) {
                if (element.cod === codigo) {
                    tit = element.valor;
                }
            });
        }
        ;
        return tit;
    };
    CommonService.prototype.addActivity = function (descr) {
        var wsUrl;
        if (!this.isLocalData()) {
            wsUrl = this.urlSer() + 'home/activity/' + KeycloakService.getLoggedUser() + '?descr=' + btoa(SharedService.unescape(encodeURIComponent(descr)));
            return this._http.get(wsUrl).map(function (response) { return response.json(); });
        }
        else {
            return new Observable(function (observer) {
                //return () => console.log("mockup observable");
                return function () { };
            });
        }
    };
    CommonService.prototype.findGeneros = function () {
        //console.log("findGeneros: app/data/genero.json"+ this._http.get(wsUrl).map(response => <Genero[]>response.json()));
        var wsUrl;
        wsUrl = "app/data/genero.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findTiposIngreso = function () {
        //console.log("findTiposIngreso: app/data/tiposIngreso.json"+ this._http.get(wsUrl).map(response => <TiposIngreso[]>response.json()));
        var wsUrl;
        wsUrl = "app/data/tiposIngreso.json";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    CommonService.prototype.findVinculosByConcepto = function (tex_cod, ttr_id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "concepto.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/tiposVinculosByConcepto?tex=" + tex_cod + "&ttr=" + ttr_id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    return CommonService;
}(SharedService));
CommonService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], CommonService);
export { CommonService };
export var SFUN = {
    "Novedades": "NOV",
    "Favoritos": "FAV",
    "Despacho": "DDI",
    "Cedulas": "CED",
    "Usuarios": "USU",
    "Expedientes": "EXP",
    "Actuaciones": "ACT",
    "Escritos": "ESC",
    "Avisos": "AVI",
    "Tasas": "TAS",
    "AltaTasa": "ALTTAS",
    "DesExp": "DESEXP",
    "Agenda": "AGEAUD",
    "PagarTasa": "PAGTAS",
    "Partes": "PAR",
    "Audiencia": "AUD",
    "ICUsaRenaper": "ICRENAPER",
    "ICMUsaRenaper": "ICMRENAPER",
    "ActOrdenarGrilla": "ACTORDENA",
    "DesExpPer": "DESEXPPER",
    "NovFilter": "NOVFILTER",
    "FavFilter": "FAVFILTER",
    "ExpRepQR": "EXPREPQR",
    "Pases": "PAS",
    "Saldos": "SALDOS",
    "RegistroPaseEstudio": "REG",
};
//# sourceMappingURL=common.service.js.map